import { UnlinkedExactLicensesFilters, UnlinkedExactLicensesTable } from "modules/UnlinkedExactLicensesDashboard/components";

export const UnlinkedExactLicensesDashboard = () => (
  <>
    <UnlinkedExactLicensesFilters />
    <UnlinkedExactLicensesTable />
  </>
);
